/**
 * KLOKI – BTS promo lišta (HP + vybrané PDP)
 * Kopírování kódu + plynulý scroll na kotvy uvnitř lišty.
 * Na BTS LP běží stejná logika v bts.js (guard __btsCopy / __btsAnchor).
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(event, payload) {
    if (!event) return;
    var data = payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data));
    if (typeof window.gtag === 'function') window.gtag('event', event, data);
    if (window.posthog && window.posthog.__loaded && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, data);
    }
  }

  function initCopy(root) {
    root.querySelectorAll('[data-bts-copy]').forEach(function (el) {
      if (el.__btsCopy) return;
      el.__btsCopy = true;
      el.addEventListener('click', function () {
        var code = el.getAttribute('data-bts-copy');
        var done = el.getAttribute('data-bts-copied-label');
        var label = el.querySelector('[data-bts-copy-label]') || el;
        var original = label.textContent;
        var write = navigator.clipboard && navigator.clipboard.writeText
          ? navigator.clipboard.writeText(code)
          : Promise.reject();
        write.catch(function () {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
        }).then(function () {
          if (done) {
            label.textContent = done;
            setTimeout(function () { label.textContent = original; }, 2000);
          }
          track('back_to_school_coupon_copy', {
            coupon_code: code,
            placement: el.getAttribute('data-bts-placement') || 'unknown'
          });
        });
      });
    });
  }

  function initAnchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.__btsAnchor) return;
      a.__btsAnchor = true;
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        if (!id || id === '#') return;
        var target = null;
        try { target = document.querySelector(id); } catch (e) { target = null; }
        /* Školní balíčky mají bundle Offer (.gsb-offer), klasický #gs-offer
           často disabled — fallback na viditelný offer blok. */
        if (!target) target = document.querySelector('.gsb-offer, .gs-offer');
        if (!target) return;
        ev.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
        history.replaceState(null, '', id);
      });
    });
  }

  function init(root) {
    if (!root) return;
    initCopy(root);
    initAnchors(root);
  }

  function boot() {
    document.querySelectorAll('[data-bts-promo-site]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bts-promo-site]')) {
      init(e.target);
    }
  });
})();
